<template>
  <v-flex xs12>
    <v-toolbar flat>
      <v-toolbar-title>Einstellungen</v-toolbar-title>
    </v-toolbar>
      <form>
        <v-select
          v-model="profile.daterange_default"
          :items="choices.daterange_default"
          label="Standardeinstellung für Zeitraum"
          :disabled="profileLoading"
        ></v-select>

        <v-select
          v-model="profile.evaluation_view"
          :items="choices.evaluation_view"
          label="Standardeinstellung für die Auswertungsansicht"
          :disabled="profileLoading"
        ></v-select>
  </form>
  </v-flex>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import { api, endpoints } from '@/api'

export default {
  name: 'Settings',
  metaInfo: {
    title: 'Einstellungen',
  },
  data () {
    return {
      loading: false,
      choices: {
        daterange_default: [
          {value: 'unfiltered', text: 'Gesamter Zeitraum'},
          {value: 'currentWeek', text: 'Aktuelle Woche'}
        ],
        evaluation_view: [
          {value: 'pivot', text: 'Gesamtübersicht'},
          {value: 'detail', text: 'Detailansicht'}
        ],
      }
    }
  },
  computed: {
    ...mapGetters([
      'profile',
      'profileLoading',
    ]),
  },
  watch: {
    profile: {
      handler () {
        let keys = Object.keys(this.choices)
        let newProfile = {}
        for (let i = 0; i < keys.length; i++) {
          let k = keys[i]
          newProfile[k] = this.profile[k]
        }
        this.setProfile({profile: newProfile})
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(['setProfile']),
  },
}
</script>

<style>
</style>
